import Icon from '@ant-design/icons';
import { Button, Space, Typography } from 'antd';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Stripe from 'stripe';
import { useContextNotifications } from '../../../context/notifications';
import { useContextUsers } from '../../../context/users';
import { useCustomerPaymentMethods, usePlans, usePaymentCreate, usePaymentUpgrade } from '../../../hooks/stripe';
import ContentCard from '../../Common/ContentCard';
import { Back } from '../../Common/Icon';
import Loading from '../../Common/Loading';
import PlansDetails from '../../Common/PlansDetails';

const Plans = () => {
  const navigate = useNavigate();

  const { profile } = useContextUsers();
  const { openNotification } = useContextNotifications();

  const getPlans = usePlans();
  const paymentCreate = usePaymentCreate();
  const upgradePayment = usePaymentUpgrade();
  const [plans, setPlans] = useState<Stripe.Plan[]>();
  const [selectedPlanId, setSelectedPlanId] = useState<string>();
  const customerPaymentMethods = useCustomerPaymentMethods();

  useEffect(() => {
    customerPaymentMethods.fetch();
  }, []);

  useEffect(() => {
    getPlans.fetch();
  }, []);

  useEffect(() => {
    if (!getPlans.data?.data) return;
    const newPlans = Object.values(getPlans.data.data).sort((a, b) => (a.amount || 0) - (b.amount || 0));

    setPlans(newPlans);
  }, [getPlans.data]);

  useEffect(() => {
    if (!profile?.planId) return;

    setSelectedPlanId(profile.planId);
  }, [profile]);

  const handleBack = () => {
    navigate({ pathname: '/profile', search: 'tab=payment' });
  };

  const handleChange = (id: string) => {
    if (!id) return;

    setSelectedPlanId(id);

    const defaultPaymentMethod =
      customerPaymentMethods.data?.data.data.find((item) => item.isDefault) ||
      customerPaymentMethods.data?.data.data[0];

    if (!defaultPaymentMethod) return;
    const selectedPlanIndex = plans?.findIndex((plan) => plan.id === selectedPlanId) as number;
    const newPlanIndex = plans?.findIndex((plan) => plan.id === id) as number;

    if (selectedPlanIndex >= 0 && newPlanIndex >= 0) {
      upgradePayment
        .fetch({
          planId: id,
          type: selectedPlanIndex > newPlanIndex ? 'Downgrade' : 'Upgrade',
        })
        .then(() => {
          handleBack();
          openNotification?.({ message: 'Plan was changed successfully' });
        });
    }
  };

  return (
    <section>
      <Loading visible={paymentCreate.loading} absolute />
      <Space direction="vertical" size={32}>
        <div className="flex-row flex-align-center flex-justify-space-between gap-12">
          <div className="flex-row flex-align-center gap-4">
            <Button type="ghost" icon={<Icon component={Back} style={{ fontSize: '1.25em' }} />} onClick={handleBack} />
            <Typography.Title>Plan</Typography.Title>
          </div>
        </div>

        <Space direction="vertical" size={12}>
          <Typography.Title level={3}>All Plans</Typography.Title>
          <ContentCard loading={getPlans.loading}>
            {plans && (
              <PlansDetails
                plans={plans}
                selectedPlan={selectedPlanId}
                handleChange={handleChange}
                loading={paymentCreate.loading}
              />
            )}
          </ContentCard>
        </Space>
      </Space>
    </section>
  );
};

export default Plans;
